var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecondaryBay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-secondary-bay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-1044.000000, -515.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-secondary-bay",
    transform: "translate(1044.000000, 515.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0.5 L21.5,0.5 C22.6045695,0.5 23.5,1.3954305 23.5,2.5 L23.5,4.5 C23.5,5.6045695 22.6045695,6.5 21.5,6.5 L2.5,6.5 C1.3954305,6.5 0.5,5.6045695 0.5,4.5 L0.5,2.5 C0.5,1.3954305 1.3954305,0.5 2.5,0.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,11.5 L21.5,11.5 C22.6045695,11.5 23.5,12.3954305 23.5,13.5 L23.5,15.5 C23.5,16.6045695 22.6045695,17.5 21.5,17.5 L2.5,17.5 C1.3954305,17.5 0.5,16.6045695 0.5,15.5 L0.5,13.5 C0.5,12.3954305 1.3954305,11.5 2.5,11.5 Z",
    id: "Rectangle"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecondaryBay);
export default __webpack_public_path__ + "static/media/icon-secondary-bay.070aad9e7b68308d9bab0b36525ec613.svg";
export { ForwardRef as ReactComponent };